<template>
  <div class="component-files">
    <div class="tips">上传实验等相关材料</div>
    <ul-button type="hollow" ref="uploader">上传文件</ul-button>
    <ul class="file-list" v-if="list.length > 0">
      <li v-for="(item, index) in list" :key="index">
        <i class="iconfont" :class="[fileIcon(item.fileUrl)]"></i>
        <a class="name" :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
        <a href="javascript:;" @click="deleteFile(index)">删除</a>
      </li>
    </ul>
  </div>
</template>

<script>
import Obs from "@/plugins/ulearning-obs.js";
import { API_HOST, RESOURCE_SERVER_HOST } from '@/config'
import { setObsConfig, fileIcon } from '@/utils/file.js'
import { mapGetters } from "vuex";
export default {
  props: ['list'],
  components: {
  },
  data() {
    return {
      tempList: JSON.parse(JSON.stringify(this.list))
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user', token: "user/token" })
  },
  mounted() {
    window.files = this
    let obs = new Obs(setObsConfig({
      uptokenHost: API_HOST,
      authorization: this.token,
      obsHost: RESOURCE_SERVER_HOST,
    }))
    obs.initUpBtn(this.$refs.uploader.$el)
    obs.onBeforeUpload = (file) => {
          
      file.onProgress = (percent) => {
        console.log('progress----file-----' + percent)
      }
      file.onSuccess = () => {
        console.log('success----file-----',file)
        file.key = file.key.toLowerCase()
        let url = file.obsHost + '/' + file.key
        this.tempList.push({
          fileName: file.name,
          fileUrl: url,
          size: file.size
        })
        this.$emit('update', this.tempList)
        console.log('上传成功地址----file-----' + url)
      }
      file.onError = (err) => {
        console.log('error----file-----' + err)
      }
    }
  },
  methods: {
    fileIcon,
    deleteFile (i) {
      this.tempList.splice(i, 1)
      this.$emit('update', this.tempList)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips{
  color: $--color-text-secondary;
  font-size: 12px;
  line-height: 1.5;
  margin: 10px 0;
}
.file-list{
  max-height: 230px;
  overflow: auto;
  padding-right: 20px;
  li{
    display: flex;
    align-content: center;
    padding: 0 10px;
    margin-top: 10px;
    background-color: $--background-color-base;
    border-radius: 4px;
    .name{
      flex: 1;
      margin: 0 10px;
      color: $--color-text-base;
      &:hover{
        color: $--color-link;
      }
    }
  }
}
</style>